import React, { useState } from 'react'
import {
  DateInput,
  ModalWrapper,
  SelectField,
  StyledButton,
  TextFields,
  Textarea,
} from '../../../../../../components'
import { Typography } from '@mui/material'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { CloseCommonSuccess, CommonSuccess } from '../../School/SchoolRegistration/components/Steps'
import { setInExpense, setLoader, setRefreshPage } from '../../../../../../redux/globalSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useGlobal, usePostApi } from '../../../../../../shared'
import { baseURL, urls } from '../../../../../../shared/config'
import axios from 'axios'
import { InfoField } from '../../School/PopOver/SchoolInfo'
import { highestInt } from '../../../../../../shared/utils/constants'

export const ExpenseForm = ({ open, handleClose, update, customRole, userSchoolId }) => {
  const dispatch = useDispatch()
  const formatDate = (dateString) => {
    const [year, month, day] = dateString.split(/-|T/)
    return `${year}-${month}-${day}`
  }
  const expenseID = useSelector((state) => state.global.expenseID)
  const data = useSelector((state) => state.global.SchoolDInfo)
  const { postApi } = usePostApi()
  const [success, setSuccess] = useState(false)
  const selectOptions = [
    { label: 'Salary', value: 'Salary' },
    { label: 'Rent', value: 'Rent' },
    { label: 'Vehicle', value: 'Vehicle' },
    { label: 'Function', value: 'Function' },
    { label: 'Maintenance', value: 'Maintenance' },
    { label: 'Others', value: 'Others' },
  ]
  // const paidToList = [
  //   { label: 'Teacher', value: 'Teacher' },
  //   { label: 'Staff', value: 'Staff' },
  //   { label: 'Driver', value: 'Driver' },
  //   { label: 'Other', value: 'Other' },
  // ]

  const { data: schoolList } = useGlobal({
    userUrl: `${urls.SCHOOL_LIST}?page=1&limit=${highestInt}`,
  })

  const handleBoxClose = () => {
    setSuccess(false)
    handleClose()
  }
  const apiUrl = update ? `${baseURL}${urls.EXPENSE_PATCH}` : urls.EXPENSE_POST
  const handleSubmit = async () => {
    dispatch(setLoader(true))
    dispatch(setInExpense(true))
    try {
      await validationSchema.validate(formik.values, { abortEarly: false })
      if (customRole != 'Admin') {
        if (!formik.values.schoolName) {
          toast.error('School is required')
          dispatch(setLoader(false))
          return
        }
      }
      const requestData = {
        expense_id: expenseID,
        school_id: customRole == 'Admin' ? userSchoolId : formik.values.schoolName,
        employee_id: formik.values.employee,
        title: formik.values.title,
        category: formik.values.category,
        date: formik.values.date,
        amount: formik.values.amount,
        description: formik.values.desc || '',
        // paid_to: formik.values.paidTo,
      }

      const response = update
        ? await axios.patch(apiUrl, requestData)
        : await postApi(apiUrl, requestData)

      if (response.status === 200 || response.status === 201) {
        setSuccess(true)
        toast.success('Expense updated successfully!')
        dispatch(setLoader(false))
        dispatch(setRefreshPage(true))
        dispatch(setInExpense(false))
        handleBoxClose()
      } else {
        toast.error(response.message)
        console.error('Error:', response)
        dispatch(setLoader(false))
        dispatch(setInExpense(false))
      }
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        error.inner.forEach((err) => {
          toast.error(err.message)
        })
      }
      dispatch(setLoader(false))
      dispatch(setInExpense(false))
    }
  }

  const initialValues = {
    title: '',
    schoolName: '',
    category: '',
    employee: '',
    date: '',
    amount: '',
    desc: '',
  }

  const validationSchema = Yup.object({
    title: Yup.string().required('Title is required'),
    // schoolName: Yup.string().required('School is required'),
    category: Yup.string().required('Category is required'),
    employee: Yup.string().required('Employee is required'),
    date: Yup.string().required('Date is required'),
    amount: Yup.string().required('Amount is required'),
    // paidTo: Yup.string().required('Paid To is required'),
  })
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  })

  const { data: employeeList } = useGlobal({
    userUrl: `${urls.EXPLOYEE_LIST}${customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : formik.values.schoolName}`,
  })

  React.useEffect(() => {
    if (data && update) {
      formik.setValues({
        title: data?.expense_title,
        schoolName: data?.school_id,
        category: data?.expense_category,
        employee: data?.employee_id,
        date: formatDate(data?.expense_date),
        amount: data?.expense_amount,
        desc: data?.expense_description,
      })
    }
  }, [data, update])
  const userSchoolName = schoolList?.find((school) => school.school_id == userSchoolId)?.school_name

  const expenseTitle = update ? 'Update Expense' : 'Add New Expense'
  if (success) {
    return (
      <ModalWrapper open={success} adminAdd title={expenseTitle} width={'440px'}>
        <div className="success-expense">
          <CommonSuccess />
          <CloseCommonSuccess handleClose={handleBoxClose} />
        </div>
      </ModalWrapper>
    )
  }
  return (
    <ModalWrapper open={open} handleClose={handleClose} title={expenseTitle} width={'500px'}>
      <div className="add-employee">
        <TextFields
          width={'100%'}
          label={'Title'}
          name={'title'}
          placeholder={'Enter Title'}
          required
          value={formik.values.title}
          onChange={formik.handleChange}
        />
        {customRole == 'Admin' || customRole === 'Superadmin' ? (
          <InfoField label={'School'} value={userSchoolName} width={'100%'} />
        ) : (
          <SelectField
            placeholder={'Select School'}
            label={'School'}
            options={(schoolList || [])?.map((prod) => ({
              value: prod.school_id,
              label: prod.school_name,
            }))}
            required
            width={'100%'}
            name="schoolName"
            value={formik.values.schoolName}
            onChange={(selectedOption) => formik.setFieldValue('schoolName', selectedOption)}
          />
        )}
        <SelectField
          placeholder={'Select Category'}
          width={'100%'}
          label={'Category'}
          options={selectOptions}
          required
          value={formik.values.category}
          onChange={(value) => formik.setFieldValue('category', value)}
        />
        <SelectField
          width={'100%'}
          placeholder={'Select Employee'}
          label={'Employee'}
          options={(employeeList || [])?.map((prod) => ({
            value: prod.employee_id,
            label: prod.employee_name,
          }))}
          required
          value={formik.values.employee}
          onChange={(value) => formik.setFieldValue('employee', value)}
        />
        <DateInput
          width={'100%'}
          name={'date'}
          label={'Date'}
          required
          value={formik.values.date}
          onChange={formik.handleChange}
        />
        <TextFields
          placeholder={'₹1000'}
          width={'100%'}
          label={'Amount'}
          name={'amount'}
          required
          value={formik.values.amount}
          onChange={formik.handleChange}
        />
        <Textarea
          placeholder={'Enter Description (optional)...'}
          width={'100%'}
          label={'Description'}
          name={'desc'}
          // required
          value={formik.values.desc}
          onChange={formik.handleChange}
        />
        {/* <SelectField
          width={'100%'}
          label={'Paid To'}
          options={paidToList}
          required
          value={formik.values.paidTo}
          onChange={(value) => formik.setFieldValue('paidTo', value)}
        /> */}
        <div className="add-employee-btns">
          <div className="in-a-row">
            <Typography onClick={handleBoxClose} className="cancel-btn">
              Cancel
            </Typography>
            <StyledButton onClick={handleSubmit}>{update ? 'Submit' : 'Add'}</StyledButton>
          </div>
        </div>
      </div>
    </ModalWrapper>
  )
}
